import classnames from 'classnames'
import Link from 'next/link'

import styles from './index.module.scss'

export type InternalNavigationLink = {
  href: string
  label: string
  quantity?: string
  isActive: boolean
}

export type InternalNavigationProps = {
  className?: string
  links: InternalNavigationLink[]
  hasIconButtons?: boolean
}

export const InternalSidebarNavigation = ({
  className,
  links,
  hasIconButtons = false,
}: InternalNavigationProps) => {
  return (
    <div className={classnames(className)}>
      <ul>
        {links.map(link => (
          <li key={link.label}>
            {/* TODO: check links styling and link component */}
            <Link
              href={link.href}
              className={classnames(styles['link'], {
                [styles['active']]: link.isActive,
                [styles['with-quantity']]: link.quantity,
              })}
            >
              <span className={classnames({ [styles['visually-hidden']]: hasIconButtons })}>
                {link.label}
              </span>
              {link.quantity && <span className={styles['badge']}>{link.quantity}</span>}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default InternalSidebarNavigation
